import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";
import { getUnitCode } from "../../utils";

export const form13 = (record: any) => {
  return {
    departmentCode: "1",
    aflType: AFLType.ApplicationForLeave,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: StringHelper.verticalBarSplit(record?.eUnit)[1],
          requestId: record.id,
          unitCode: getUnitCode(record),
        },
      },
      {
        type: "title",
        value: {
          sub: ["(Dành cho Phó Trưởng Trung tâm nghỉ 01 ngày và Cán bộ Đội)"],
        },
      },
      {
        type: "salutation",
        value: [
          "Giám đốc VIAGS Tân Sơn Nhất;",
          `Trưởng ${StringHelper.verticalBarSplit(record?.eUnit)[1]}`,
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
          },
          {
            type: "eWorkPlace",
            value: `${StringHelper.verticalBarSplit(record?.eTeam)[1]}-${
              StringHelper.verticalBarSplit<string[]>(record?.eBranch)[1]
            }`,
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Ông Giám đốc/Trưởng trung tâm đồng ý giải quyết cho tôi được nghỉ phép năm ${new Date().getFullYear()}. lần thứ ${
              record?.ePaidLeaveTimes || ""
            }.`,
          },
          {
            type: "",
            value: `Số lượng phép theo tiêu chuẩn:${record?.ePaidLeaveRemain} ngày (trong TH nghỉ phép từ lần thứ 2 trở đi, chỉ ghi rõ số ngày phép còn lại chưa thực hiện).`,
          },

          {
            type: "eVacationPeriods",
            value: record?.eVacationPeriods,
            docxType: "paragraph",
          },
          { type: "eLeavePlace", value: record?.eLeavePlace },
          { type: "ePhoneNumber", value: record?.ePhone },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value:
              "Rất mong nhận được sự chấp thuận của Giám đốc/Trưởng trung tâm.",
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", `- Lưu: VT, ${getUnitCode(record)}.`],
          },
          {
            type: "signature1",
            value: ["THỦ TRƯỞNG ĐƠN VỊ", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["PHÊ DUYỆT CỦA GIÁM ĐỐC", record?.eSteps[2][0].name],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
